import { render, staticRenderFns } from "./RssSettings.vue?vue&type=template&id=0418c586&scoped=true&"
import script from "./RssSettings.vue?vue&type=script&lang=ts&"
export * from "./RssSettings.vue?vue&type=script&lang=ts&"
import style0 from "./RssSettings.vue?vue&type=style&index=0&id=0418c586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0418c586",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VSwitch,VTextField})
